import React, { Component } from 'react';
import { Panel } from 'widgets/default/panel';
import { PanelBody } from 'widgets/default/panel/body';
import { Header } from 'widgets/default/Header';
import { ExperienceChart } from './experienceChart';

class ExperienceWidget extends Component {

  render() {

    const { supplier: { uid: supplierId } } = this.props;

    return (
      <Panel>
        <Header title="Experience (Number of tasks and Coordinators who assigned them)" />
        <PanelBody>
          <ExperienceChart supplierId={supplierId}/>
        </PanelBody>
      </Panel>
    );
  }
}

export { ExperienceWidget }
